import * as React from 'react';
import { NavigationProps, MuleSoftBrandData } from 'lib/types';
import { Button, Icon, Modal, Tooltip } from '@salesforce/design-system-react';
import FakeLookup from 'lib/FakeLookup';
import './mulesoft.css';
import { withBrandData } from 'lib/withBrand';

interface CardProps extends NavigationProps {
	icon?: string;
	iconWidth?: number;
	name: string;
	industry: string;
	tooltip: {
		description: string,
		imageSource: string,
		title: string,
	};
}

class MulesoftCard extends React.Component<CardProps, {open: boolean}> {
	constructor (props: CardProps) {
		super(props);
		this.state = { open: false };
	}

	componentDidMount() {
		// tslint:disable-next-line:no-any
		document.body.addEventListener('click', this.closeTooltip as any);
	}

	componentWillUnmount() {
		// tslint:disable-next-line:no-any
		document.body.removeEventListener('click', this.closeTooltip as any);
	}

	openTooltip = (e: React.MouseEvent) => {
		const target = e.target as HTMLElement;
		const rect = target.getBoundingClientRect();

		this.setState({open: true});

		setTimeout(
			() => {
				const tooltip = document.getElementById('mulesoft-info-tooltip') as HTMLElement;
				if (tooltip) {
					tooltip.style.top = `${rect.top - 37}px`;
					tooltip.style.left = `${rect.left + 30}px`;
				}
			},
			0
		);
	}

	closeTooltip = (e: React.MouseEvent) => {
		this.setState({open: false});
	}

	render () {
		const {icon, industry, name, navClick, tooltip} = this.props;
		const iconWidth = this.props.iconWidth ? this.props.iconWidth : 24;
		const iconClassName = (icon || '').replace('/assets/images/mulesoft/', '').split('.')[0];

		return (
			<div className="mulesoft-tile">
				<h4 className="slds-text-heading_small slds-text-title_caps">
					<img src="/assets/icons/mule-rest-api.svg" height="18" width="18" />
					REST API
					<Tooltip 
						align="right"
						content={
							<div>
								<h4 className="slds-text-heading_small">{tooltip.title}</h4>
								<a href="javascript(void);">Salesforce Customer 360 Ready</a>
								<p>{tooltip.description}</p>
								<img src={tooltip.imageSource} />
								<Button 
									iconCategory="utility"
									iconName="new_window"
									iconPosition="left"
									label="Learn More" 
								/>
							</div>
						}
						id="mulesoft-info-tooltip"
						position="overflowBoundaryElement"
						isOpen={this.state.open}
						triggerStyle={{
							background: '#fff'
						}}
					>
						<a href="javascript:void(0)" onMouseOver={this.openTooltip} onMouseLeave={this.closeTooltip}>
							<Icon
								category="utility"
								name="info_alt"
								size="x-small"
								style={{fill: '#9B9B9B'}}
							/>
						</a>
					</Tooltip>
				</h4>
				<div className="icon">
					{icon ?
						(icon.includes('/') ?
							<img 
								className={`mulesoft-icon-${iconClassName}`}
								src={icon}
								style={{marginTop: '2px'}}
								height={iconWidth}
								width={iconWidth} 
							/> :
							<Icon category="utility" name={icon} size="small" style={{fill: '#4bca81'}} />) :
						<img src="/assets/icons/mule-rest-api.svg" height="24" width="24" />
					}
				</div>
				<p className="name">{name}</p>
				<p className="industry slds-text-body_small">{industry}</p>
				<Button label="Connect" onClick={navClick} />
			</div>
		);
	}
}

// tslint:disable:max-line-length
// tslint:disable:jsx-self-close
const MulesoftIcon = () => (
	<svg height="36" width="36" viewBox="0 0 36 36">
		<circle r="18" transform="translate(18, 18)" fill="#032E61" />
		<path fill="#FFF" transform="scale(0.4) translate(13, 13)" d="M56,32 C56,41.6373333 50.3173333,49.944 42.1226667,53.7626667 L40.0053333,45.864 C44.7893333,43.096 48.0133333,37.9253333 48.0133333,32 C48.0133333,29.304 47.3413333,26.7626667 46.1653333,24.5333333 L35.336,40 L28.6666667,40 L17.8346667,24.5333333 C16.6586667,26.7626667 15.9866667,29.304 15.9866667,32 C15.9866667,37.9253333 19.2106667,43.096 23.9946667,45.864 L21.8773333,53.7626667 C13.6826667,49.944 8,41.6373333 8,32 C8,23.6266667 12.2906667,16.2586667 18.792,11.9653333 L32,30.824 L45.208,11.9653333 C51.7093333,16.2586667 56,23.6266667 56,32 Z M64,32 C64,49.672 49.672,64 32,64 C14.328,64 0,49.672 0,32 C0,14.328 14.328,0 32,0 C49.672,0 64,14.328 64,32 Z M61.3333333,32 C61.3333333,15.8 48.2,2.66666667 32,2.66666667 C15.8,2.66666667 2.66666667,15.8 2.66666667,32 C2.66666667,48.2 15.8,61.3333333 32,61.3333333 C48.2,61.3333333 61.3333333,48.2 61.3333333,32 Z">
		</path>
	</svg>
);
// tslint:enable:max-line-length
// tslint:enable:jsx-self-close

interface MulesoftProps extends NavigationProps {
	brandData: MuleSoftBrandData;
	isOpen: boolean;
}

// Convert this to a modal
const Mulesoft: React.SFC<MulesoftProps> = ({ brandData, isOpen, navClick }) => (
	<Modal
		// containerClassName={['matching-rules_modal1']}
		// footer={}
		isOpen={isOpen}
		// onRequestClose={}
		size="large"
		title={<span><MulesoftIcon /> Anypoint Exchange</span>}
	>
		<div className="mulesoft">
			<div className="mulesoft-tiles">
				<h2 className="slds-text-heading_large">Connect to {brandData.api}s</h2>
				<FakeLookup className="lookup" entity="All" placeholder={`Search ${brandData.api}s`} />
				{brandData.cards.map(card => (
					<MulesoftCard
						icon={card.icon}
						iconWidth={card.iconWidth}
						industry={card.industry}
						name={card.name}
						navClick={navClick}
						tooltip={brandData.cardInfo}
					/>
				))}
			</div>
		</div>
	</Modal>
);

export default withBrandData('mulesoft', Mulesoft);


// WEBPACK FOOTER //
// ./src/DataSources/Mulesoft.tsx